<template>
  <div class="home">
    <LeadComponent />
    <ContentComponent />
  </div>
</template>

<script>
// @ is an alias to /src
import LeadComponent from '@/components/Lead.vue';
import ContentComponent from '@/components/Content.vue';

export default {
  name: 'home',
  components: {
    LeadComponent,
    ContentComponent,
  },
  data() {
    return {
    };
  },
  methods: {
    scrollToElement(slug) {
      const element = document.querySelector(`[data-slug=${slug}]`);
      if (element) {
        const ua = window.navigator.userAgent;
        const msie = ua.indexOf('MSIE ');
        // If Internet Explorer, return version number
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
          setTimeout(() => {
            window.scroll(0, element.offsetTop - 130);
          }, 1000);
        }

        window.scrollTo({
          behavior: 'smooth',
          left: 0,
          top: element.offsetTop - 130,
        });
        setTimeout(() => {
          element.classList.toggle('current');
        }, 1500);
        setTimeout(() => {
          element.classList.toggle('current');
        }, 3500);
      }
    },
  },
  mounted() {
    this.$store.dispatch('loadItems');
    setTimeout(() => {
      this.scrollToElement(this.$route.params.slug);
    }, 500);
  },
  watch: {
    $route() {
      this.scrollToElement(this.$route.params.slug);
    },
  },
};
</script>

<style scoped lang="css">
</style>
<style>
.barbershop.current {
  transform: scale(1.1);
}
</style>
